<script lang="ts" setup>
import { computedAsync } from '@vueuse/core';
import FormsService from '../../../runtime/services/FormsService';
import FieldSelect from './FieldSelect.vue';

defineOptions({
    name: 'FieldForm',
    components: {
        'field-select': FieldSelect
    }
});

const model = defineModel<number | null>();
const props = withDefaults(defineProps<{
    label: string;
    category: number | null;
    invalidFeedback?: (value: any) => string;
    required?: boolean;
    disabled?: boolean;
    name?: string;
}>(), {
    invalidFeedback: null,
    required: false,
    disabled: false,
    name: undefined
});

const { $alert } = useAlerts();
const { $log } = useLogging();
const category = computed(() => props.category);

watch(category, (value: number, old: number): void =>
{
    if (value != old)
    {
        model.value = null;
    }
});

const options = computedAsync(async () =>
{
    try
    {
        const pager = new Pager(1, 10000, 'Title', 'ASC');
        const response = await FormsService.getOptions(pager, props.category, null, null);

        return [{ value: null as any, text: '' }, ...response.items];
    }
    catch (ex)
    {
        handleException($log, ex, {
            400: (ex: any) => $alert.warning(ex.message)
        });

        return [];
    }
});
</script>

<template>
    <FieldSelect
        v-if="options"
        v-model="model"
        :name="name"
        :options="options"
        :label="props.label"
        :invalid-feedback="props.invalidFeedback"
        :required="props.required"
        :disabled="props.disabled"
    />
</template>
